import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "@/services/api/baseApi";
import authReducer from "@/features/auth/authSlice";
import tablePrefsReducer from "@/features/tables/tablePrefsSlice";
import uploadWatchReducer from "@/features/invoices/uploadWatchSlice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    tablePrefs: tablePrefsReducer,
    uploadWatch: uploadWatchReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

/**
 * Wires the focus/reconnect events that RTK Query's `refetchOnFocus` and
 * `refetchOnReconnect` listen for. Without this they are silently inert — the
 * flags parse fine and simply never fire.
 */
setupListeners(store.dispatch);
